import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import useDidUpdateEffect from '../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../common/html/element'
import { formatVal } from '../../../helpers/value'
import { PopupCompanyList } from '../popupCompanyList'
import {
  changeFilter,
  resetStore,
  selectCell,
  selectCompanyDetailPagination,
  selectCompanyIds,
  selectFilter,
  selectLoading,
} from './store/slice'
import { getDetailData } from './store/thunk'

export const HandleDetail = ({
  children,
  isFormatChildren,
  path,
  otherParams,
  style,
  triggerShow,
  disabled,
  hiddenSelectAll,
  isDynamicReport,
}) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const settingParams = useSettingParams()
  const filter = useSelector(selectFilter)
  const isLoading = useSelector(selectLoading)

  const [isShowPopup, setIsShowPopup] = useState(false)

  const allowShow = children !== 0 && !disabled

  const getListCompany = () => {
    const params = {
      ...settingParams,
      ...filter,
      ...otherParams,
    }

    const thunk = () => {
      dispatch(getDetailData({ path, params }))
    }

    return { thunk, dependencies: [JSON.stringify(params)] }
  }

  const onClick = () => {
    if (allowShow) {
      setIsShowPopup(true)
    }
  }

  const setPage = (value) => {
    dispatch(
      changeFilter({
        page: value,
      }),
    )
  }

  const setPageSize = (value) => {
    dispatch(
      changeFilter({
        pageSize: value,
        page: 1,
      }),
    )
  }

  useDidUpdateEffect(() => {
    setIsShowPopup((prev) => !prev)
  }, [triggerShow])

  useDidUpdateEffect(() => {
    if (!isShowPopup) {
      dispatch(resetStore())
    }
  }, [isShowPopup])

  return (
    <>
      <Element
        elementName="span"
        className={allowShow ? 'cursorPointer' : 'default'}
        style={{
          color: !allowShow || isDynamicReport ? '#3a414b' : '#0553A5',
          ...style,
        }}
        onClick={onClick}
      >
        {isFormatChildren ? formatVal(children, locale, false, 0) : children}
      </Element>
      {isShowPopup && (
        <PopupCompanyList
          isShowPopup={isShowPopup}
          setIsShowPopup={setIsShowPopup}
          isLoading={isLoading}
          selectIds={selectCompanyIds}
          selectDataFromRedux={selectCell}
          getListCompany={getListCompany}
          selectPaginationInfo={selectCompanyDetailPagination}
          setPage={setPage}
          setPageSize={setPageSize}
          hiddenSelectAll={hiddenSelectAll}
        />
      )}
    </>
  )
}

HandleDetail.propTypes = {
  isFormatChildren: PropTypes.bool,
  path: PropTypes.string.isRequired,
  otherParams: PropTypes.object,
  style: PropTypes.object,
  triggerShow: PropTypes.bool,
  disabled: PropTypes.bool,
  hiddenSelectAll: PropTypes.bool,
}

HandleDetail.defaultProps = {
  isFormatChildren: true,
  otherParams: {},
  style: {},
  disabled: false,
  hiddenSelectAll: false,
}
